import { render, staticRenderFns } from "./ShareType.vue?vue&type=template&id=da485802"
import script from "./ShareType.vue?vue&type=script&lang=js"
export * from "./ShareType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports